/**
 * Dependencies for tearing down a minimized call dock without restoring UI.
 */
export interface ClearDockOnlyTeardownDeps {
  /** True when CallsFullScreenContent is still mounted (Phone Call dialog open). */
  callDialogIsMounted: boolean;
  clearMinimizeNavigation: () => void;
  closeCallDialog: () => void;
  clearMinimizedCallId: () => void;
  removeJustInTimeCall: () => void;
}

/**
 * Dismiss minimized-call chrome after the guide leaves a continuing conference.
 * Closes the mounted Phone Call dialog before clearing minimize state so the
 * fullscreen surface does not slide back up.
 *
 * @param deps - Navigation cancel, dialog close, and Redux clear callbacks.
 */
export function performClearDockOnlyTeardown(
  deps: ClearDockOnlyTeardownDeps
): void {
  deps.clearMinimizeNavigation();

  // Close while still "minimized" so clearing minimizedCallId cannot expand UI.
  if (deps.callDialogIsMounted) {
    deps.closeCallDialog();
  }

  deps.clearMinimizedCallId();
  deps.removeJustInTimeCall();
}
